import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("hacienda-lang") || "en";
  });

  useEffect(() => {
    window.localStorage.setItem("hacienda-lang", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = useCallback(
    (path) => {
      const keys = path.split(".");
      let node = translations[language];
      for (const k of keys) {
        if (node && Object.prototype.hasOwnProperty.call(node, k)) {
          node = node[k];
        } else {
          return path;
        }
      }
      return node;
    },
    [language]
  );

  const toggle = useCallback(() => setLanguage((l) => (l === "en" ? "es" : "en")), []);

  const value = useMemo(
    () => ({ language, setLanguage, toggle, t }),
    [language, toggle, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
